// Bandeau de choix sur les cookies : affiché sur toutes les pages tant que le
// visiteur n'a pas répondu, puis plus jamais (le choix se change depuis la page
// « Cookies »).
//
// « Accepter » et « Refuser » ont le même poids visuel : refuser doit être aussi
// simple qu'accepter. Et le bandeau ne bloque pas la page — on peut lire, et
// même se connecter, sans avoir répondu.
import { Button } from '../components/ui';
import { Link } from '../router';
import { setCookieChoice, useCookieChoice } from './cookieConsent';
import './legal.css';

export function CookieBanner() {
  const choice = useCookieChoice();
  if (choice) return null;

  return (
    <aside className="cookie-banner" role="region" aria-label="Cookies">
      <p>
        <strong>Cookies.</strong>{' '}
        <span className="cookie-banner-long">
          Zygosight n’utilise aucun traceur ni publicité. Le cookie de connexion est indispensable.{' '}
        </span>
        Acceptez-vous que vos préférences d’affichage (thème, filtres) soient aussi mémorisées dans ce navigateur ?{' '}
        <Link to="/cookies">En savoir plus</Link>
      </p>
      <div className="cookie-banner-actions">
        <Button variant="ghost" onClick={() => setCookieChoice('refused')}>
          Refuser
        </Button>
        <Button variant="ghost" onClick={() => setCookieChoice('accepted')}>
          Accepter
        </Button>
      </div>
    </aside>
  );
}
